import React, { type PropsWithChildren } from 'react';
import { useReadOnly, useSelected } from 'slate-react';
import styles from './SelectionRectangle.module.css';
import classnames from 'classnames';

interface SelectionProps {
  // Whether to fill the background when selected.
  hasBackgroundFill?: boolean;
  // Whether to have a margin around the element before the selection border.
  hasMargin?: boolean;
  // Whether the selection element is inline.
  inline?: boolean;
  // Whether the selection element should fill its entire container.
  fill?: boolean;
}

// Show a selection rectangle around an element when it is selected. In the
// `element` prop is
const SelectionRectangle: React.FC<PropsWithChildren<SelectionProps>> = ({
  children,
  hasBackgroundFill,
  hasMargin,
  inline = false,
  fill = false,
}) => {
  const selected = useSelected();
  const readOnly = useReadOnly();

  if (typeof hasMargin === 'undefined') hasMargin = true;
  hasBackgroundFill ||= false;

  // Never render the selection rectangle if we're read-only
  if (readOnly) {
    return children;
  }

  return (
    <span
      className={classnames(styles.selectionRectangle, {
        [styles.selectionRectangleInline]: inline,
        [styles.selectionRectangleSelected]: selected,
        [styles.selectionRectangleMargin]: hasMargin,
        [styles.selectionRectangleFill]: fill,
        [styles.selectionRectangleBackground]: selected && hasBackgroundFill,
      })}
    >
      {children}
    </span>
  );
};

export default SelectionRectangle;
